import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { INavbarLink } from '../../../types/navbar';
import { ERubric } from '../../../types/rubricsLinks';
import { NavBarNavItem } from '../NavBarNavItem';

interface INavBarProps {
  regionId: number;
  excludeSuburbanRegionsIds: number[];
  isAuthenticated: boolean;
  rubricsLinks: INavbarLink[];
  specialPromo: React.ReactNode;
  navbarRef: React.RefObject<HTMLDivElement | null>;
  onItemMouseOver(rubric: ERubric): void;
  onItemMouseOut(): void;
}

export const NavBar: React.FC<INavBarProps> = ({
  regionId,
  excludeSuburbanRegionsIds,
  rubricsLinks,
  specialPromo,
  isAuthenticated,
  navbarRef,
  onItemMouseOut,
  onItemMouseOver,
}) => {
  const isWideSpecialPromo = excludeSuburbanRegionsIds.includes(regionId) && specialPromo;

  return (
    <nav
      className={clsx(
        styles['navigation'],
        isAuthenticated && styles['is-authenticated'],
        isWideSpecialPromo && styles['is-wide-special-promo'],
        specialPromo && styles['has-special-promo'],
      )}
      data-testid="navbar-redesign"
      ref={navbarRef}
    >
      <ul className={styles['list']}>
        {rubricsLinks.map(({ rubric, active, hovered, title, component, url }) => {
          if (component) {
            return (
              <li key={rubric} className={styles['list-item']} onMouseOver={() => onItemMouseOver(rubric)}>
                {component}
              </li>
            );
          }

          return (
            <NavBarNavItem
              key={rubric}
              rubric={rubric}
              title={title}
              url={url}
              className={clsx(
                styles['list-item'],
                active && styles['active'],
                hovered && styles['hovered'],
                // для регионов с длинными названиями спецпроектов мы не показываем раздел Дома и участки
                // (из-за того, что в хэдере нет места)
                excludeSuburbanRegionsIds.includes(regionId) && rubric === ERubric.Countryside && styles['invisible'],
              )}
              linkClassName={styles['link']}
              onItemMouseOver={onItemMouseOver}
              onItemMouseOut={onItemMouseOut}
            />
          );
        })}
      </ul>
      {specialPromo && <div className={styles['special-promos']}>{specialPromo}</div>}
    </nav>
  );
};
